import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import styles from './TextSection.module.scss';

const TextSection: PageComponent = () => {
    // TODO: check responsive
    return (
        <section className={`container ${styles.section}`}>
            <h1>UAB "Esnet"</h1>
            <div className="row">
                <div className="col-sm-12 col-lg-10 m-auto text-center">
                    <p>
                        <Trans
                            i18nKey="text.first"
                            ns="landingInformationAboutCompany"
                        >
                            specializuojasi duomenų centrų paslaugų srityje nuo
                            2007 metų. Pasirinkę UAB "Esnet" paslaugas klientai
                            ne tik sumažina savo sąnaudas, bet ir sutaupo laiką.
                        </Trans>
                    </p>
                    <p>
                        <Trans
                            i18nKey="text.second"
                            ns="landingInformationAboutCompany"
                        >
                            UAB "Esnet" valdydama nuosavą duomenų centrą
                            kontroliuoja visą paslaugų teikimo procesą, todėl
                            gali teikti ne tik kompleksines paslaugas, bet ir
                            užtikrinti aukštą paslaugų pasiekiamumą už
                            konkurencingą kainą. Ilgametę patirtį turinti įmonė
                            nuolat investuoja į duomenų centro infrastruktūrą
                            taip didindama paslaugų spektrą bei gerindama jų
                            kokybę. Bendrovė skiria ypatingą dėmesį klientų
                            problemų sprendimui siekdama ilgalaikio tarpusavio
                            bendradarbiavimo.
                        </Trans>
                    </p>

                    <p>
                        <Trans
                            i18nKey="text.third"
                            ns="landingInformationAboutCompany"
                        >
                            Lankstūs sprendimai, ilgametė patirtis,
                            konkurencinga paslaugų kaina bei nuolatinis
                            tobulėjimo procesas - tai savybės dėl kurių verta
                            rinktis Mus.
                        </Trans>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default TextSection;
